module.exports = __webpack_public_path__ + "static/bc125130-89c4-462a-9e34-6e78c272cfbf-fb258e39f5d58535d57b6efded75cab9.webp";